export const GEOSPOOF_REDUCER_NAMES = {
  HISTORY: 'history',
  SEARCH: 'search',
  STATE: 'state',
};
